import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ModernGovernanceHero from "./sections/ModernGovernanceHero";
import PublicTrustMetrics from "./sections/PublicTrustMetrics";
import CoreErpModules from "./sections/CoreErpModules";
import ExecutiveEndorsement from "./sections/ExecutiveEndorsement";
import GovernmentalSegments from "./sections/GovernmentalSegments";
import EcosystemIntegrations from "./sections/EcosystemIntegrations";
import LeadershipVision from "./sections/LeadershipVision";
import Quadrants from "./sections/Quadrants";
import ProfessionalConsultation from "./sections/ProfessionalConsultation";
import SupportUs from "./sections/Support us";
import StrategicInsights from "./sections/StrategicInsights";
import InstitutionalPartners from "./sections/InstitutionalPartners";
import FinalEngagement from "./sections/FinalEngagement";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ModernGovernanceHero />
      <PublicTrustMetrics />
      <CoreErpModules />
      <ExecutiveEndorsement />
      <GovernmentalSegments />
      <EcosystemIntegrations />
      <LeadershipVision />
      <Quadrants />
      <ProfessionalConsultation />
      <SupportUs />
      <StrategicInsights />
      <InstitutionalPartners />
      <FinalEngagement />
      <Inquiry />
      <Footer />
    </div>;
}